import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http'; // ✅ Add this line

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DefaultModule } from './layouts/default/default.module';
import { ChartService } from './modules/service/chart.service';
import * as moment from 'moment';
import { NgTippyModule } from 'angular-tippy';
import { MatTableModule } from '@angular/material/table';
import { CdkTableModule } from '@angular/cdk/table';
import { RoleModifierInterceptor } from './interceptors/role-modifier.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';


@NgModule({
  declarations: [
    AppComponent,
    // BrokerAdminComponent,
    // MessagesComponent,
  ],
  imports: [
    BrowserModule,
    HttpClientModule, // ✅ Add this here
    AppRoutingModule,
    BrowserAnimationsModule,
    DefaultModule,
     MatTableModule,
    CdkTableModule
  ],
  providers: [
    ChartService,
     {
      provide: HTTP_INTERCEPTORS,
      useClass: RoleModifierInterceptor,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
